var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.videoData)?_c('div',{staticClass:"player"},[_c('Xgplayer',{ref:"videoPlayer",attrs:{"config":_vm.config}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }